var map = {
	"./marcella/arroz_de_bacalhau.js": 181,
	"./marcella/bacalhau_com_natas.js": 182,
	"./marcella/lasanha_de_berinjela.js": 183,
	"./marcella/macarrao_ao_molho_de_camarao.js": 184,
	"./marcella/prawns_fried_rice.js": 185,
	"./marcella/strogonoff_de_cogumelos.js": 186
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 180;